import { render, staticRenderFns } from "./projectApproval.vue?vue&type=template&id=f34398be&scoped=true"
import script from "./projectApproval.vue?vue&type=script&lang=js"
export * from "./projectApproval.vue?vue&type=script&lang=js"
import style0 from "./projectApproval.vue?vue&type=style&index=0&id=f34398be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34398be",
  null
  
)

export default component.exports